<template>
  <div class="product content-part">
    <div class="banner"></div>
    <div class="video">
      <video
        src="./../assets/images/product/视频.mp4"
        preload="auto"
        controls="controls"
        autoplay
      >
        您的浏览器不支持 video 标签
      </video>
    </div>
    <section class="wrapper style1">
      <div class="list-all">
        <div class="row-list row-left">
          <section
            class="col-4 col-12-narrower list"
            v-for="(item, index) in list"
            :key="index"
          >
            <div class="post">
              <img
                class="logo"
                alt=""
                :src="require(`./../assets/images/product/${item.id}.png`)"
              />
              <div class="inner">
                <h4>
                  {{ item[`name_${locale}`] }}
                </h4>
              </div>
            </div>
          </section>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [
        {
          name_CN: "负荷预测",
          id: 6,
          name_EN: "Load Forecasting",
        },
        {
          name_CN: "机理模型",
          id: 5,
          name_EN: "Mechanism model",
        },
        {
          name_CN: "路径寻优",
          id: 4,
          name_EN: "Path optimization",
        },
        {
          name_CN: "全局优化",
          id: 3,
          name_EN: "Global optimization",
        },
        {
          name_CN: "神经网络",
          id: 2,
          name_EN: "Neural network",
        },
        {
          name_CN: "人工智能",
          id: 1,
          name_EN: "Artificial intelligence",
        },
      ],
      params: {
        pageNo: 1,
        pageSize: 8,
      },
      totals: 0,
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
  mounted() {
    // this.getList();
  },
  methods: {
    getList(type) {
      this.params.pageNo = type ? type : 1;
      this.$http
        .get("/api/portal/product/queryPage", {
          params: this.params,
        })
        .then((res) => {
          console.log(res);
          this.list = res.data && res.data.items ? res.data.items : [];
          this.totals =
            res.data && res.data.page && res.data.page.rowCount
              ? res.data.page.rowCount
              : 0;
        });
    },
    more(id) {
      let url =
        window.location.protocol +
        "//" +
        window.location.host +
        "/proDetail?id=" +
        id;
      window.open(url);
    },
  },
};
</script>

<style lang="less" scoped>
.product {
  .banner {
    height: 8vh;
    background-color: rgba(0, 0, 0, 1);
  }
  .video {
    video {
      width: 100%;
    }
  }
  .wrapper {
    margin-top: 100px;
  }
  .list-all {
    margin: 0 auto;
  }
}
.logo {
  width: 103px;
  height: 103px;
  margin: 0 auto;
  margin-bottom: 10px;
  // cursor: pointer;
}
.inner {
  text-align: center;
}
.row-list {
  display: flex;
  justify-content: center;
}
.list {
  margin: 0 56px;
}
.post {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 80px;
  .inner {
    h4 {
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/product.vue